import { render, staticRenderFns } from "./DeliveryLegacy.vue?vue&type=template&id=f0899c76"
import script from "./DeliveryLegacy.vue?vue&type=script&lang=js"
export * from "./DeliveryLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports